<div class="divisa-col-12 my-3">
  <div style="display: inline-flex;">
    <button
      mat-mini-fab
      color="primary"
      [attr.aria-label]="'BACK_BUTTON.ARIA_BACK_TO_LANDING' | translate"
      (click)="goBack()"
    >
      <mat-icon svgIcon="arrow_back"></mat-icon>
    </button>
    <h5 class="ml-4 mt-1">{{ title }}</h5>
  </div>
</div>
